import { feedbotToast } from '../../../../../../lib/feedbotToast'

export const toastNotifyCopyTelephoneNumberSuccess = () => {
  const id = 'copyTelephoneNumberSuccess'

  const title = 'Succesfully copied'
  const content = 'Phone number copied to the clipboard'

  feedbotToast.success({ title, content, id })
}
